import Form from 'react-bootstrap/Form';
import {useNavigate} from 'react-router-dom';
import React, { useState, useEffect } from "react"
import FailTitleDiv from '../components/shared/TitleDiv.js';
import FailIconDiv from '../components/fail/FailIconDiv.js';
import FailMsgDiv from '../components/fail/FailMsgDiv.js';
import EnquiryDiv from '../components/fail/EnquiryDiv.js';
import FailMobileDiv from '../components/fail/FailMobileDiv.js';
import '../css/FailMessage.css';

function FailMessage(props) {
    let data = "";
    const PUBLIC_URL =process.env.PUBLIC_URL;
    const eventName = window.name;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const navigate = useNavigate();
    const bgColor = process.env.REACT_APP_BG_COLOR;
    const iconUrl = baseUrl + "frontend/api/Enroll/GetImageURLbyStatus";
    const eventUrl = baseUrl + "frontend/api/Enroll/GetEventStatus";
    const [iconImg, setIconImg] = useState();

    let page = "enroll";

    const [content, setContent] = useState({
      AllButton_Color: "",
      AllButton_FontColor: "",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color: "#FFFFFF"
    });

    if (props.isInternal && props.locid !== ""){
      page = "enrollm1_internal?int_loc_id=" + props.locid ;
    }
    
    if (props.isFullQuota){
      data = {
        "title" : "您選擇之門市登記名額已滿",
        "msg" : "抱歉！您選擇之門市登記名額已滿，請按此 返回頁面 並重新輸入。",
        "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/" + page
      };
    } else if (props.isFullQuotaCarnival0914 || props.isFullQuotaCarnival0915){
      data = {
        "title" : "您選擇之登記日子名額已滿",
        "msg" : "抱歉！您選擇之登記日子名額已滿，請選擇其它日子。"
      };
    } else if (props.isFullQuotaCarnival2025){
      data = {
        "title" : "您選擇之登記時段名額已滿",
        "msg" : "抱歉！您選擇之登記時段名額已滿，請選擇其它時段。"
      };
    } else if (props.isFullQuotaTastingCertificate){
      data = {
        "title" : "您選擇之登記日子名額已滿",
        "msg" : "抱歉！您選擇之登記日子名額已滿，請選擇其它日子。"
      };
        
    } else if (props.isFullQuotaTSTopening){
      data = {
        "title" : "您選擇之登記日子名額已滿",
        "msg" : "抱歉！您選擇之登記日子名額已滿，請選擇其它日子。"
      };
        
    } else if (props.isDuplicate){
        data = {
          "title" : "輸入的手提號碼已被使用",
          "msg" : "您輸入的手提號碼已被使用，請按此 返回頁面 及重新輸入。",
          "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/" + page
        };
    } else if (props.hasCurrentCycleTx){
      data = {
        "title" : "已曾經預購今期的賀年糕點",
        "msg" : "已曾經預購今期的賀年糕點，請按此 返回頁面 及重新輸入。",
        "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/multi/enrollm1step1"
      };
    } else if (props.isNotMultiBatch){
      data = {
        "title" : "已沒有期數可預購",
        "msg" : "已沒有期數可預購，請按此 返回頁面 及重新輸入。",
        "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/multi/enrollm1step1"
      };
    } else if (props.isWrongFormat){
      data = {
        "title" : "輸入手提號碼格式錯誤",
        "msg" : "你輸入的手提號碼不是有效的電話格式，請按此 返回頁面 及重新輸入手提電話號碼以完成預購訂單。",
        "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/" + page
      };
    } else if (props.isInternalOnly){
      data = {
        "title" : "此活動只限門市預購",
        "msg" : "此活動只限門市預購，請按此 返回頁面 及重新輸入。",
        "return_url" : "../" + process.env.PUBLIC_URL
      };
    } else if (props.isRegError) {
      data = {
        "title" : "系統繁忙",
        "msg" : "系統繁忙，請放心，按返回後，重新輸入手提電話號再次嘗試就可。",
        "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/" + page
      };
    
    //Show the error code
    if (props.errcode !== null && props.errcode.length === 5){
        data.msg += "[代碼:" + props.errcode + "]";
      }
    } else if (props.isWrongUrl) {
      data = {
        "title" : "輸入的網址連結不正確",
        "msg" : "按此 回到官方網站。",
        "return_url" : "../" + process.env.PUBLIC_URL
      };
    } else if (props.isExpiredStamp) {
      data = {
        "title" : "輸入的試食印花網址連結已過期",
        "msg" : "按此 回到官方網站。",
        "return_url" : "../" + process.env.PUBLIC_URL
      };
    } else if (props.isEventNotEffective){
      data = {
        "title" : "活動連結明天生效",
        "msg" : "按此 回到官方網站。",
        "return_url" : "../" + process.env.PUBLIC_URL
      };
    } else {
      data = {
        "title" : "系統繁忙",
        "msg" : "系統繁忙，請放心，按返回後，重新輸入手提電話號再次嘗試就可。",
        "return_url" : '../' + PUBLIC_URL + '/' + eventName + "/enroll"
      };
    } 

    useEffect(() => {
      fetch(iconUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "Event_Name": eventName,
          "Status": "Fail"
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        setIconImg(result.url);
      })
      .catch(err => { 
        console.log(err); 
      });
    }, []);

    
    useEffect(() => {
      fetch(eventUrl, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        //console.log(result);
        if (result.IsSuccess == null){
          setContent(previousState => {
            return { 
              ...previousState,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color
            }
          });
        } else {
          setContent(previousState => {
            return { 
              ...previousState,
              AllButton_Color : "#0d6efd",
              AllButton_FontColor : "#FFFFFF",
              AllTitle_Color : "#0d6efd",
              AllTitle_FontColor : "#FFFFFF",
              AllBackground_Color : "#e9e6e1"
            }
          });
        }
      })
      .catch(err => { 
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-error');
        console.log(err); 
       });

    }, []);

  return (
    <>
      <Form style={{backgroundColor: content.AllBackground_Color}}>
          <FailTitleDiv class="title" title={data.title} bgColor={content.AllTitle_Color} fontColor={content.AllTitle_FontColor}></FailTitleDiv>
          <div className="d-grid">
              { !props.isWrongUrl && !props.isExpiredStamp && <FailIconDiv class="icon" src={iconImg} />}
              <FailMsgDiv class="msg" msg={data.msg} returnurl={data.return_url}></FailMsgDiv>
              {
                props.isFullQuotaCarnival0914 &&
                <>
                  <FailMsgDiv class="msg-middle" msg="日子選項" ></FailMsgDiv>
                  <FailMsgDiv class="info" msg="登記預領9月15日中秋試食嘉年華入場門券" returnurl={'../' + PUBLIC_URL + '/20240915_mid_carnival' + "/" + page}></FailMsgDiv>
                </>
              }
              {
                props.isFullQuotaCarnival0915 &&
                <>
                  <FailMsgDiv class="msg-middle" msg="日子選項" ></FailMsgDiv>
                  <FailMsgDiv class="info" msg="登記預領9月14日中秋試食嘉年華入場門券" returnurl={'../' + PUBLIC_URL + '/20240914_mid_carnival' + "/" + page}></FailMsgDiv>
                </>
              }
              { props.isWrongFormat && <FailMobileDiv class="info"></FailMobileDiv>}
              <EnquiryDiv class="info"></EnquiryDiv>
          </div>
      </Form>
    </>
  );
}

export default FailMessage;
